import React from 'react';
import Lottie from 'react-lottie';
import './Rupee_Lottie.css';
import * as animationData from './Rupee_Lottie.json';

function Rupee_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Rupee_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Rupee_Lottie;